import React from 'react';
import { ReactComponent as Alert } from './alert.svg'

export default ({ height = 24, width = 24, style, ...props }) => <div {...props} style={{ height, width, ...style }}><Alert style={{ color: '#fff', fill: '#FEB2D4' }} /></div>